import React from "react";
import {
  Header,
  GlobalNavigation,
  NavigationList,
  NavigationDropdownItem,
  NavigationListItem,
  MainBar,
} from "@sainsburys-tech/fable";
import "../App/App.scss";
import { getUserFullName, signOut } from "../../utils/authn";
import { NavLink, useLocation } from "react-router-dom";

const links = [
  {
    id: "Alerts",
    path: "/alerts",
    search: '?status=["Open"]',
    name: "Alerts"
  },
  {
    id: "Stores",
    path: "/stores",
    search: "",
    name: "Stores"
  },
  {
    id: "LightingOverrides",
    path: "/lighting/overrides",
    search: "",
    name: "Lighting overrides"
  }
];

const NavigationBar = (props) => {
  const location = useLocation();
  const pathNameString = location.pathname;

  return (
    <>
      <Header>
        <GlobalNavigation style={{ display: "flex", justifyContent: "flex-end", alignItems: "center" }}>
          <span style={{ fontWeight: 400, marginRight: "1rem", fontSize: "0.875rem" }}>{getUserFullName()}</span>
          <NavigationList>
            <NavigationListItem onClick={() => signOut()} style={{ fontWeight: 700, cursor: "pointer" }}>
              Logout
            </NavigationListItem>
          </NavigationList>
        </GlobalNavigation>
        <hr style={{ margin: 0, border: "none", borderTop: "1px solid #e0e0e0" }} />
        <MainBar>
          <MainBar.AppName style={{ fontSize: "2rem", lineHeight: "1.25", fontWeight: 700, fontFamily: "MaryAnn, Trebuchet MS, Arial, Helvetica, sans-serif" }}>Connected Buildings</MainBar.AppName>
          <MainBar.Navigation>
            <NavigationList>
              {links.map((link, key) => {
                let route = link.path;
                if (link.search) {
                  route += link.search;
                }
                return (
                  <NavigationListItem
                    key={key}
                    isActive={pathNameString === link.path}
                    as={NavLink}
                    to={route}
                  >
                    {link.name}
                  </NavigationListItem>
                );
              })}
            </NavigationList>
          </MainBar.Navigation>
        </MainBar>
        <hr style={{ margin: 0, border: "none", borderTop: "1px solid #e0e0e0" }} />
      </Header>
      <div className="fable:pt-4">
        <main>{props.children}</main>
      </div>
    </>
  );
};

export default NavigationBar;
